import { Row, Col } from 'react-bootstrap';
import { Column } from 'primereact/column'
import { useContext, useState, useEffect } from 'react';
import Card from '../../ui/Card';
import swal from 'sweetalert';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons'
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import Spinner from 'react-bootstrap/Spinner';
import BaseService from '../../../services/BaseService';
import CommonService from "../../../services/CommonService";
import DataGrid from '../../GenericComponents/DataGrid';
import { toast } from 'react-toastify';
import { UserContext } from '../../../UserContext';

const IssuerFilerAssociations = (props) => {
  const user = useContext(UserContext);
  const [isLoading, setIsLoading] = useState(true);
  const [issuers, setIssuers] = useState([]);  //Issuer list
  const [issuerFilerAssocs, setIssuerFilerAssocs] = useState([]); //Issuer Filer Association list
  const [organizations, setOrganizations] = useState([]); //Organization list
  const [orgId, setOrgId] = useState("");
  const [addAssocError, setAddAssocError] = useState("");
  const [selectedIssuers, setSelectedIssuers] = useState([]); //Issuers in Issuer list for new association


  const handleOrgChange = (e, key) => {
    const checkValue = e.length > 0 ? e[0][key] : '';
    setOrgId(checkValue);

    if (checkValue) {
      setAddAssocError('');
      setSelectedIssuers([]);
      getIssuerFilerAssocs(checkValue);

    }
  }


  const handleIssuerChange = (selectedOptions) => {
    setSelectedIssuers(selectedOptions);

  }


  const handleAddAssocBtn = (e) => {
    if (!orgId) {
      setAddAssocError('Please select an organization');
      return;
    }
    if (selectedIssuers?.length === 0) {
      setAddAssocError('Please select issuer(s)');
      return;
    }

    setAddAssocError('');

    //Call backend code to create the associations
    var obj = {
      msgId: null,
      sysId: null,
      opr: "createIssuerOrgAssocs",
      hdrStruct: null,
      queryParam: null,
      reqData: {
        "orgId": orgId,
        "issuerIds": selectedIssuers,
        "loginUser": CommonService.getUserName(user),
      },

    };

    BaseService.processRequest(obj)
      .then((result) => {
        if (result.data.errors && result.data.errors.length > 0) {
          toast.error(result.data.errors[0].message);
        }
        else {
          toast.success("New issuer / filer association(s) added successfully!");
          setSelectedIssuers([]);
          //Also call the backend to get the newly created association(s)
          getIssuerFilerAssocs(orgId);

        }

      });

  }


  const handleDeleteAssoc = (assoc) => {
    let warningMsg = "";
    warningMsg = "Deleting this issuer/filer association will prevent this organization from submitting, editing, or viewing reports on behalf of the associated issuer.";

    swal({
      title: "Are you sure?",
      text: warningMsg,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
      .then((willDelete) => {
        if (willDelete) {
          var obj = {
            msgId: "null",
            sysId: null,
            opr: "deleteIssuerOrgAssoc",
            hdrStruct: null,
            queryParam: null,
            reqData: {
              "issuerOrgAssocId": assoc.issuerOrgAssociationId
            },
          };

          BaseService.processRequest(obj)
            .then((res) => res)
            .then((result) => {
              if (result.data.errors && result.data.errors.length > 0) {
                toast.error(result.data.errors[0].message);
              } else {
                toast.success("Issuer Filer Association Deleted Successfully");
                getIssuerFilerAssocs(orgId);
              }
            })
        }
      });
  }


  useEffect(() => {
    getIssuers();
    getOrganizations();
  }, []);


  const getOrganizations = () => {
    var obj = {
      msgId: null,
      sysId: null,
      opr: "getOrganizationNames",
      hdrStruct: null,
      queryParam: null,
      reqData: {},
    };

    BaseService.processRequest(obj)
      .then((res) => res)
      .then((result) => {
        Object.keys(result.data.responses).forEach((key) => {
          setOrganizations(result.data.responses[key]);
        });
        setIsLoading(false);

      });
  }


  const getIssuers = () => {
    var obj = {
      msgId: null,
      sysId: null,
      opr: "getIssuers",
      hdrStruct: null,
      queryParam: null,
      reqData: {},
    };

    BaseService.processRequest(obj)
      .then((res) => res)
      .then((result) => {
        Object.keys(result.data.responses).forEach((key) => {
          setIssuers(result.data.responses[key]);
        });
        setIsLoading(false);

      });
  }


  const getIssuerFilerAssocs = (selectedOrgId) => {   //Get list of associations for the selected Organization.
    var obj = {
      msgId: null,
      sysId: null,
      opr: "getIssuersOrgByOrgId",
      hdrStruct: null,
      queryParam: null,
      reqData: {
        "orgId": selectedOrgId,
      },
    };

    BaseService.processRequest(obj)
      .then((res) => res)
      .then((result) => {
        Object.keys(result.data.responses).forEach((key) => {
          setIssuerFilerAssocs(result.data.responses[key]);
        });
        setIsLoading(false);

      });
  }


  const viewFormatter = (row, rowIndex) => {
    return (
      <div style={{ textAlign: "center", lineHeight: "normal" }}>
        <FontAwesomeIcon icon={faTrash} className="custom-icon" onClick={(e) => handleDeleteAssoc(row)} />
      </div>
    );
  }


  const columnsAssoc = [{
    dataField: 'issuerName',
    text: 'Issuer Name',
    sort: true,
  }, {
    dataField: 'issuerStatus',
    text: 'Status',
    sort: true,
  }, {
    dataField: "",
    text: "Action",
    formatter: viewFormatter
  },
  ];


  return (
      <form onSubmit={(e) => e.preventDefault()}>
        <Card>
          <div className="panel panel-default">
            <div className="panel-heading">
              <div className="container">
                <div id="packet_id" className="panel-title">
                  <h1 className="menu-title">Issuer / Organization Associations</h1>
                </div>
              </div>
            </div>
            <div className="panel-body">
              <div className="container">
                <div className="form">
                  {isLoading && <Spinner animation="border" variant="primary" />}
                  <Row>
                    <Col md={12}>
                      <div className="control">
                        <label>Organizations: </label>
                        <Typeahead
                          placeholder="Choose an organization"
                          id="orgId"
                          labelKey="orgName"
                          onChange={e => handleOrgChange(e, "orgId")}
                          inputProps={{ 'data-validations': 'required', name: 'orgId' }}
                          options={organizations}
                          sort
                        />
                      </div>
                    </Col>

                  </Row>

                  <div style={{ overflow: 'auto' }}>
                    <div className="fleft w-100">
                      <div>
                        <a href="/admin" className="dk-blue-color link-button" style={{ float: 'left' }}>Back to Admin</a>
                      </div>
                    </div>
                  </div>

                  <hr />

                  {/* Issuer/Org Association grid */}
                  <Row>
                    <Col md={12}>
                      <div className="control">
                        <label>Issuer: </label>
                        <Typeahead
                          placeholder="Choose Issuer(s)"
                          id="issuerId"
                          labelKey="issuerName"
                          onChange={e => handleIssuerChange(e)}
                          inputProps={{ 'data-validations': 'required', name: 'issuerId' }}
                          multiple
                          options={issuers}
                          selected={selectedIssuers}
                          sort
                        />
                      </div>

                    </Col>
                  </Row>
                  <div style={{ overflow: 'auto' }}>
                    <div className="fleft w-100">
                      <div style={{ float: 'right' }}>
                        <div>
                          <button className="custom-button bg-success text-light rounded" style={{ float: 'right' }} onClick={handleAddAssocBtn} >
                            Add New Issuer / Filer Association(s)
                          </button>
                        </div>
                      </div>
                    </div>
                    <div style={{ float: 'right' }}>
                      <p className="error"> {addAssocError}</p>
                    </div>
                  </div>
                  <div>
                    <DataGrid
                      title="Issuer / Filer Associations:"
                      dataSource={issuerFilerAssocs}
                      sortField='issuerOrgAssocId'
                      showQuickSearch={false}
                      emptyDataMessage='No data available to display'
                    >
                      {columnsAssoc.map((column, i) => {
                          return (
                            <Column
                              key={i}
                              field={column.dataField}
                              header={column.text}
                              body={column.formatter}
                              hidden={column.hidden}
                            />)
                        })
                      }
                    </DataGrid>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Card>
      </form>

  )
}

export default IssuerFilerAssociations
